import { useQuery } from "react-query";
import { fetchConditionScoreData } from "./api";

export function useConditionScore(filters, options={}) {
    return useQuery(["fetchConditionScoreData", filters], () => fetchConditionScoreData(filters), {
      staleTime: 0, 
      ...options
    })
  }